import React, { useState, useEffect } from 'react';
import styles from '../styles/title.module.css';

function MovieHeader({ currentCategory }) {
    const [header, setHeader] = useState([]);
    
    useEffect(() => {

        const categoryHeader = {
            popular: 'Popular Movies',
            top_rated: 'Top Rated Movies',
            now_playing: 'Now Playing Movies',
            upcoming: 'Upcoming Movies',
            trending: 'Trending Movies',
            horror: 'Horror Movies',
            action: 'Action Movies',
            comedy: 'Comedy Movies',
            drama: 'Drama Movies',
            adventure: 'Adventure Movies',
            crime: 'Crime Movies',
        
        };

        const movieHeader = categoryHeader[currentCategory];

        setHeader(movieHeader);
    }, [currentCategory]);

    return (
        <div>
            <h1 className={styles['MovieHeader']}>{header}</h1>
        </div>

    );
}

export default MovieHeader;

